import Message from '@acri-tools/react-tools/components/Message/Message';
import Search from '@acri-tools/react-tools/components/Search/Search';
import Select from '@acri-tools/react-tools/components/Select/Select';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import { searchParamsQuery } from '@acri-tools/react-tools/utils/query';
import request from '@acri-tools/react-tools/utils/request';
import React,{Component} from 'react';
import { connect } from 'react-redux';
import KPI2GraphMode from '../../../../components/KPI2GraphMode/KPI2GraphMode';
import { API_URL } from '../../../../_utils/config';
import { load_product_types } from '../../../../_utils/product_types';

interface Props{
    // REDUX
    product_types?:any
}
interface State{
    count: number
    searchParams: any
    entities?: Array<any>
    filters: any
    filterEnabled: boolean

    loading?: boolean

    message?: string
    messageType?: string

    // update
    entity?: any
    loading_entity: boolean

    updateLoading: boolean
    updateMessage: string
    updateMessageType: string
}


class SearchKPI2GraphMode extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            count: 0,
            searchParams:{
                search: '',
                offset: '0',
                limit: '10',
    
                orderby: 'id',
                orderbyDirection: 'desc',
            },
            filters:{
                "id": { active:true },
                "name": { active:true },
            },
            filterEnabled: false,
    
            // update
            loading_entity: false,

            updateLoading: false,
            updateMessage: '',
            updateMessageType: 'error',
        }
    }

    componentDidMount() {
        load_product_types()
        this.search();
    }

    render(){
        return (
            <>
                <div className="panel panel-full">
                    <div className="title-1">Search KPI 2 graph mode</div>
                    <div className="subtitle-1">Search KPI 2's graph modes using the following criteria</div>
                    <br/>


                    <Search orderby={['id','name','creation_date']} count={this.state.count}
                        filters={this.state.filters} searchParams={this.state.searchParams} search={this.search} >
                        <div className="results">
                            <div className="results-table">
                                <table className="dark">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Config count</th>
                                            <th>Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.entities &&
                                            this.state.entities.map(( entity:any, idx:number )=>(
                                                <tr key={idx}>
                                                    <td>{entity.id}</td>
                                                    <td>{entity.name}</td>
                                                    <td>{ entity.products?.length}</td>
                                                    <td>
                                                        <div className="search-operations">
                                                            <div className="search-operation custom-button inverted alt icon-only" 
                                                                onClick={()=>{ this.view(entity) }}>
                                                                <i className="fas fa-eye"/>
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        VIEW
                                                                    </div>
                                                                </div>
                                                            </div>    
                                                            <div 
                                                                className="search-operation custom-button inverted red alt icon-only" 
                                                                onClick={()=>{ 
                                                                    this.delete(entity) 
                                                                }}
                                                            >
                                                                <i className="fas fa-times"/>
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        DELETE
                                                                    </div>
                                                                </div>
                                                            </div>    
                                                        </div>    
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Search>
                    
                </div>

                    {
                        this.state.loading_entity ?
                            <div className="panel panel-big">
                                <div className="centered">
                                    <Spinner white/>
                                </div>
                            </div>
                        :
                        this.state.entity &&
                        <div className="panel panel-big">
                                
                            <div className="title-1">Update graph mode</div>
                            <div className="subtitle-1">Update the selected KPI 2 graph mode</div>
                            <br/>
                            <div className="form">
                                <div className="form-field">
                                    <label>Name</label>
                                    <input 
                                        type="text" value={ this.state.entity.name } placeholder={"Name"}
                                        onKeyDown={this.onEnter} onChange={(e)=>{ this.onChange({ name: e.target.value }) }}/>
                                    
                                </div>
                                {
                                    this.state.entity.products &&
                                    <>
                                        <KPI2GraphMode
                                            products={this.state.entity.products}
                                            on_add={()=>{ this.forceUpdate(); }}
                                            update={(update:any)=>{ this.forceUpdate(); }}
                                            remove={(idx)=>{
                                                let { products } = this.state.entity;
                                                products.splice(idx, 1);
                                                this.forceUpdate()
                                            }}
                                        />
                                    </>
                                }
                                <br/>
                                <br/>
                                <Message message={ this.state.updateMessage } type={ this.state.updateMessageType }/>
                                
                                {
                                    this.state.updateLoading ?
                                        <div className="custom-button disabled inverted alt">
                                            <Spinner white width={12}/> UPDATING GRAPH MODE
                                        </div>
                                    :
                                        <div className="custom-button green inverted alt" onClick={this.update}>
                                            <i className="fas fa-pen"/> UPDATE GRAPH MODE
                                        </div>
                                }
                            </div>
                        </div>
                    }
            </>
        );
    }

    input_date = (date: string) =>{
        let d = new Date(date);
        let s = `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
        return s;
    }

    onChange = ( update:any ) =>{
        this.setState({
            message: '',
            entity:{ ...this.state.entity, ...update }, 
        });
    }

    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.update();
        }
    }

    search = async() =>{
        this.setState({ loading:true });
        try{
            let res = await request(`${API_URL}/api/v1/kpi_2_graph_modes`,{
                method:'get',
                params:{
                    ...searchParamsQuery(this.state.searchParams, this.state.filters),
                    count: true
                },
            })
            this.setState({ entities: res.data.value, count: res.data.count });
        }
        catch(e){
            axiosErrorHandler( e, { 
                functionName: 'search', 
                requestName: 'search_kpi_2_graph_modes',
            })
            this.setState({
                loading:false,
                message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                messageType: 'error'
            })
        }
        finally{
            this.setState({ loading:false })
        }
    }

    delete = (entity: any) =>{
        if(window.confirm(`Are you sure you want to delete kpi 2 graph mode '${entity.name}' ?`)){
            request(`${API_URL}/api/v1/kpi_2_graph_modes/${entity.id}`,{
                method:'delete',
            })
            .then((res:any)=>{
                this.search();
            })
            .catch(e=>{
                axiosErrorHandler( e, { 
                    functionName: 'delete', 
                    requestName: 'delete_kpi_2_graph_modes',
                })
            })
        }
    }

    view = async(e:any) =>{
        this.setState({ loading_entity:true })
        try{
            let res = await request(`${API_URL}/api/v1/kpi_2_graph_modes/${e.id}`,{
                method:'get',
            })
            this.setState({ entity: res.data, updateMessage:'' });
        }
        catch(e){

            axiosErrorHandler( e, { 
                functionName: 'view', 
                requestName: 'view_kpi_2_graph_mode',
            })
        }
        finally{
            this.setState({ loading_entity:false })
        }
    }

    update = async() =>{
        if(window.confirm(`Are you sure you want to update graph mode '${this.state.entity.name}' ?`)){
            this.setState({ updateLoading:true });
            try{
                let { entity } = this.state;
                let { id } = entity;
                delete entity.id;
                let res = await request(`${API_URL}/api/v1/kpi_2_graph_modes/${id}`,{
                    method:'put',
                    data: entity,
                })
                await this.setState({ 
                    entity: res.data.value,
                    updateMessage: res.data.message,
                    updateMessageType: 'success'
                });
                this.search();
            }
            catch(e){
                axiosErrorHandler( e, { 
                    functionName: 'update', 
                    requestName: 'update_kpi_2_graph_mode',
                })
                this.setState({
                    updateMessage: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                    updateMessageType: 'error'
                })
            }
            finally{
                this.setState({ updateLoading:false });

            }
        }
    }
};


export default connect((state:any)=>{
    return {
        product_types: state.product_types
    }
})(SearchKPI2GraphMode);
